<datex-grid #$gridComponent *ngIf="initialized " [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"



>
    <ng-container topToolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch">
    </div>
  </ng-container>


  <ng-container gridColumnDef="PlcInstructions">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.PlcInstructions.displayControl.styles.style"
          [ngClass]="row.cells.PlcInstructions.displayControl.styles.classes"
          [matTooltip]="row.cells.PlcInstructions.displayControl.tooltip">{{row.cells.PlcInstructions.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ToteContainer_LookupCode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ToteContainer_LookupCode.displayControl.styles.style"
          [ngClass]="row.cells.ToteContainer_LookupCode.displayControl.styles.classes"
          [matTooltip]="row.cells.ToteContainer_LookupCode.displayControl.tooltip">{{row.cells.ToteContainer_LookupCode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Type_Description">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Type_Description.displayControl.styles.style"
          [ngClass]="row.cells.Type_Description.displayControl.styles.classes"
          [matTooltip]="row.cells.Type_Description.displayControl.tooltip">{{row.cells.Type_Description.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Type_Name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Type_Name.displayControl.styles.style"
          [ngClass]="row.cells.Type_Name.displayControl.styles.classes"
          [matTooltip]="row.cells.Type_Name.displayControl.tooltip">{{row.cells.Type_Name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
